import {z} from 'zod';

import {driverInformationSchema} from './driverInformationSchema';

export const orderInsuranceFormSchema = (isFieldRequired: (name: string) => boolean) =>
  z
    .object({
      completionAtDate: isFieldRequired('completionAtDate') ? z.date() : z.date().nullish(),
      completionAtTime: isFieldRequired('completionAtTime') ? z.string() : z.string().nullish(),
      totalPriceEstimated: isFieldRequired('totalPriceEstimated')
        ? z.number()
        : z.number().nullish(),
      note: z.string().nullish(),
      insuranceCompany: isFieldRequired('insuranceCompany') ? z.string() : z.string().nullish(),
      insuranceTypeId: isFieldRequired('insuranceType') ? z.string() : z.string().nullish(),
      insuranceEventNumber: isFieldRequired('insuranceEventNumber')
        ? z.string()
        : z.string().nullish(),
      insuranceClaimNumber: isFieldRequired('insuranceClaimNumber')
        ? z.string()
        : z.string().nullish(),
      mileage: isFieldRequired('mileage') ? z.number().min(0) : z.number().min(0).nullish(),
      fuelTank: isFieldRequired('fuelTank') ? z.number() : z.number().nullish(),
      initialInspectionPerformed: z.boolean().nullish(),
      vatDeducatible: z.boolean().nullish(),
      unblockingOfPayment: z.boolean().nullish(),
      coverLetter: z.boolean().nullish(),
      returnUsedPart: z.boolean().nullish(),
      serviceOrderGroupId: isFieldRequired('serviceOrderGroupId')
        ? z.string()
        : z.string().nullish(),
      serviceCenterId: isFieldRequired('serviceCenterId') ? z.string() : z.string().nullish(),
      insuranceClaimOccurrenceAt: isFieldRequired('insuranceClaimOccurrenceAt')
        ? z.string()
        : z.string().nullish(),
      cancelReason: z.string().nullish(),
      email: z.string().nullish(),
      phone: z.string().nullish(),
    })
    .merge(driverInformationSchema);

export type OrderInsuranceFormType = z.infer<ReturnType<typeof orderInsuranceFormSchema>>;
